/* Courted · Find a spot (T3): a fine day with time for it ("Saturday looks good for a hike") and where to go —
   the outdoor places you both like, then the ones near home you haven't answered, nearest first — each with
   Plan it for that day. A page over This week; reached from the slot, Home's nudge, Discover and the Thursday
   push (/courted/spot?date=2026-10-31). */
import React from 'react';
import * as H from './helpers.js';
import * as W from './weather.js';
import { Ico, Plate, Page, Google, Wx, track } from './ui.jsx';

const { useEffect, useState, useRef } = React;
const uuid = () => (crypto.randomUUID ? crypto.randomUUID() : String(Date.now()) + Math.random().toString(16).slice(2));

/* Somewhere else (Ben, 29 Oct): a place of your own, from Google's search near home; picking it plans it for the
   day. Nothing from the search is kept but the place's id. */
function SomewhereElse({ search, onPick }) {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState('');
  const [res, setRes] = useState([]);
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(null);
  const session = useRef(uuid());
  useEffect(() => {
    if (q.trim().length < 2) { setRes([]); return undefined; }
    const t = setTimeout(() => {
      search(q.trim(), session.current).then((r) => { setRes(r); setErr(''); })
        .catch((e) => setErr(e && e.status === 429 ? 'That’s a lot of searching. Try again in a bit.' : 'Couldn’t look that up just now.'));
    }, 250);
    return () => clearTimeout(t);
  }, [q]);
  if (!open) return <button type="button" className="dv-btn dv-btn-soft co-else-open" onClick={() => { setOpen(true); track('courted_spot_else', { action: 'opened' }); }}><Ico n="i-search" s />Somewhere else</button>;
  return (
    <section className="co-sec co-else">
      <h2 className="co-display co-h2">Somewhere else</h2>
      <label className="dv-field co-else-field"><span className="dv-sr">A place near home</span>
        <input type="search" value={q} autoFocus maxLength={100} placeholder="A park, a trail, a town" autoComplete="off" onChange={(e) => setQ(e.target.value)} /></label>
      {res.length ? (
        <div className="dv-list dv-list-inset" role="list">
          {res.map((r) => (
            <button key={r.id} type="button" role="listitem" className="dv-row co-else-row" disabled={!!busy} onClick={() => { setBusy(r.id); session.current = uuid(); Promise.resolve(onPick(r)).finally(() => setBusy(null)); }}>
              <span className="dv-row-text"><span>{r.name}</span>{r.detail ? <small>{r.detail}</small> : null}</span>
              <span className="dv-pill dv-pill-pop">{busy === r.id ? '…' : 'Plan it'}</span>
            </button>
          ))}
        </div>
      ) : null}
      {err ? <p className="co-wet" role="alert">{err}</p> : null}
    </section>
  );
}
const near = (cardsById) => (a, b) => ((cardsById[a.id] || {}).minutes ?? 999) - ((cardsById[b.id] || {}).minutes ?? 999);

function Row({ id, card, cat, kind, liked, solo, theirs, onOpen, onPlan, load }) {
  const name = (cat && cat.name) || (card && card.name) || '';
  return (
    <div className="dv-row co-spot">
      <button type="button" className="co-spot-tap" onClick={() => onOpen(id)}>
        <Plate card={card} kind={kind} load={load} className="th" />
        <span className="dv-row-text"><span>{name || ' '}</span>
          <small>{card ? [H.whatOf(card, cat), card.minutes ? card.minutes + ' min' : null].filter(Boolean).join(' · ') : ' '}</small>
          {liked ? <span className="co-who"><Ico n="i-heart-f" s />{solo ? 'You said yes' : 'You both like it'}</span> : theirs ? <span className="co-who"><Ico n="i-heart-f" s />{theirs} said yes</span> : null}</span>
      </button>
      <button type="button" className="dv-pill dv-pill-pop" onClick={() => onPlan(id)}>Plan it</button>
    </div>
  );
}

export function SpotR({ date, today, wx, chance, ideas, nearby, theirYes = {}, cardsById, catById, partner, words, country, from, onBack, backLabel, onOpen, onPlan, onSwipe, onNeed, search, onElse }) {
  const d = wx ? wx[date] : null;
  const good = chance && chance.date === date;
  const liked = ideas.filter((i) => i.kind === 'outdoors').sort(near(cardsById));
  // your partner's outdoor yeses first, then the deck's, nearest first
  const others = nearby.filter((id) => !liked.some((i) => i.id === id)).map((id) => ({ id, yes: !!theirYes[id] }))
    .sort((a, b) => (b.yes - a.yes) || near(cardsById)(a, b)).slice(0, 8);
  useEffect(() => { onNeed([...liked.map((i) => i.id), ...nearby.slice(0, 12)]); }, [liked.length, nearby.length]);
  useEffect(() => { track('courted_nudge', { action: 'opened', from: from || 'week', good: !!good }); }, [date]);
  const words2 = good ? W.chanceWords(chance, today, { country, hike: words.hike, partner: !!partner }) : null;
  const title = words2 ? words2.title : W.dayName(date, today) + ', somewhere outside';
  const line = words2 ? words2.line : d ? W.weatherWords(d, country).replace(/^./, (c) => c.toUpperCase()) + '.' : null;
  let n = 0;
  return (
    <Page onBack={onBack} back={backLabel} label={title} className="co-spotpage">
      <div className="co-pbody co-spothead">
        {d ? <Wx d={d} country={country} /> : null}
        <h1 className="co-display">{title}</h1>
        {line ? <p className="co-sub">{line}</p> : null}
        {d && W.wetDay(d) ? <p className="co-wet">{W.wetWords(W.wetDay(d), date, today, words.hike).replace(' now', '')}</p> : null}
      </div>
      {liked.length ? (
        <section className="co-sec">
          <h2 className="co-display co-h2">{partner ? 'You both like' : 'You said yes'}</h2>
          <div className="dv-list dv-list-inset">{liked.map((i) => <Row key={i.id} id={i.id} card={cardsById[i.id]} cat={catById[i.id]} kind="outdoors" liked solo={!partner} onOpen={onOpen} onPlan={onPlan} load={n++ < 12} />)}</div>
        </section>
      ) : null}
      {others.length ? (
        <section className="co-sec">
          <h2 className="co-display co-h2">{liked.length ? 'Or somewhere new' : 'Near home'}</h2>
          <div className="dv-list dv-list-inset">{others.map((i) => <Row key={i.id} id={i.id} card={cardsById[i.id]} cat={catById[i.id]} kind="outdoors" solo={!partner} theirs={i.yes && partner ? partner.name : null} onOpen={onOpen} onPlan={onPlan} load={n++ < 12} />)}</div>
        </section>
      ) : !liked.length ? (
        <div className="co-empty"><p>Finding places near home…</p></div>
      ) : null}
      {search ? <SomewhereElse search={search} onPick={onElse} /> : null}
      {!liked.length ? <button type="button" className="dv-quiet co-notfor" onClick={onSwipe}>Swipe on {words.hikes.toLowerCase()} near home</button> : null}
      <Google weather />
    </Page>
  );
}
